import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-table"
}
const _hoisted_2 = { class: "el-table__cell" }
const _hoisted_3 = { class: "cell header" }
const _hoisted_4 = {
  key: 0,
  class: "el-table__cell"
}
const _hoisted_5 = { class: "el-table__cell" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "visiting-companies__display-row" }
const _hoisted_8 = { class: "company" }
const _hoisted_9 = { class: "floor" }
const _hoisted_10 = { class: "suite" }
const _hoisted_11 = {
  key: 0,
  style: {"width":"100px"}
}
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = {
  key: 0,
  class: "visiting-companies__editor-row"
}
const _hoisted_14 = {
  class: "el-table__cell",
  colspan: "2"
}
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = { class: "visiting-companies__display-row" }
const _hoisted_17 = { class: "company" }
const _hoisted_18 = { class: "floor" }
const _hoisted_19 = { class: "suite" }
const _hoisted_20 = { class: "double-line" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" (Special Request) ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "OK", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "visitForm",
      class: "visiting-companies",
      "label-position": "top",
      model: _ctx.visitModel
    }, {
      default: _withCtx(() => [
        (_ctx.editable || _ctx.visitDisplayList.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.trans("label.visiting-company")), 1)
                  ]),
                  (_ctx.editable)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_4))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitDisplayList, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.company.tenantName), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.floor.floorName), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(item.suite.name), 1)
                        ])
                      ])
                    ]),
                    (_ctx.editable)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_button, {
                              type: "danger",
                              size: "small",
                              onClick: ($event: any) => (_ctx.removeVisitCompany(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.trans("label.remove")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              (_ctx.editable && (_ctx.multiple || _ctx.visitDisplayList.length == 0))
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_el_form_item, {
                            prop: "combineId",
                            rules: {
									required: _ctx.visitDisplayList.length == 0,
									message: _ctx.trans(
										'message.field_require',
										_ctx.trans('label.visiting-company')
									)
								}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                ref: "company",
                                modelValue: _ctx.visitModel.combineId,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visitModel.combineId) = $event)),
                                placeholder: _ctx.trans('label.nothing-selected'),
                                "fit-input-width": "",
                                "default-first-option": "true",
                                filterable: "",
                                "filter-method": _ctx.filterCompany,
                                clearable: "",
                                onBlur: _ctx.onBlur
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCompanies, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.display,
                                      value: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.company.tenantName), 1),
                                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.floor.floorName), 1),
                                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.suite.name), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "filter-method", "onBlur"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.editable && _ctx.visitDisplayList.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "No assigned visiting companies."
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showSr,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showSr) = $event)),
      title: "Company's Special Request",
      "append-to-body": true,
      "show-close": false,
      "lock-scroll": "",
      onClose: _ctx.closeSpecialRequest
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _ctx.closeSpecialRequest
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "140px",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "tenantName",
              label: _ctx.trans('label.company-name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specialRequest.tenantName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.specialRequest.tenantName) = $event)),
                  maxlength: 200,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "contactPerson",
              label: _ctx.trans('label.key-contact-person')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactPerson1,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.specialRequest.contactPerson1) = $event)),
                          maxlength: "50",
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactPerson2,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.specialRequest.contactPerson2) = $event)),
                          maxlength: "50",
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactPerson3,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.specialRequest.contactPerson3) = $event)),
                          maxlength: "50",
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "contactNo",
              label: _ctx.trans('label.key-contact-no')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactNo1,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.specialRequest.contactNo1) = $event)),
                          maxlength: 20,
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactNo2,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.specialRequest.contactNo2) = $event)),
                          maxlength: 20,
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.specialRequest.contactNo3,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.specialRequest.contactNo3) = $event)),
                          maxlength: 20,
                          "show-word-limit": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { prop: "remarks" }, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.trans("label.remarks")) + " ", 1),
                  _hoisted_21,
                  _hoisted_22
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specialRequest.remarks,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.specialRequest.remarks) = $event)),
                  type: "textarea",
                  maxlength: 500,
                  autosize: {
						minRows: 5,
						maxRows: 10
					},
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ], 64))
}